import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CircularProgress } from '@mui/material';
import qs from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';

import ErrorPanel from 'components/ErrorPanel';
import { ROUTES } from 'enum';
import { redirectToPWDReset } from 'views/SignUpForm/scenario-actions';
import { clearError } from 'store/user/actions';
import { errorSelector } from 'store/user/selectors';
import '../login-form.scss';

function ResetPwdEmailConfirmation() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { search } = useLocation();
  const error = useSelector(errorSelector);
  const { username, token } = useMemo(() => qs.parse(search), [search]);
  const normalizedUsername = typeof username === 'string' ? username.replace(' ', '+') : '';
  const shouldCheckToken = Boolean(token && normalizedUsername);
  const localError = shouldCheckToken ? '' : 'Incorrect link';

  useEffect(() => {
    if (shouldCheckToken) {
      dispatch(
        redirectToPWDReset({
          token,
          username: normalizedUsername,
        }),
      );
    }
  }, [dispatch, normalizedUsername, shouldCheckToken, token]);

  useEffect(
    () => () => {
      if (error) {
        dispatch(clearError());
      }
    },
    [dispatch, error],
  );

  const handleErrorClose = () => {
    dispatch(clearError());
    history.replace(ROUTES.SIGN_UP);
  };

  return (
    <div className="form-container">
      {localError || error ? (
        <ErrorPanel
          type="warning"
          message={localError || error}
          buttonClickHandler={handleErrorClose}
          dataTestId="password-reset-email-confirmation-error"
        />
      ) : (
        <CircularProgress />
      )}
    </div>
  );
}

export default ResetPwdEmailConfirmation;
